<template>
    <div
        class="fixed z-40 h-[72px] w-full border-b border-gray-850 bg-gray-900 lg:static"
    >
        <div class="container-fluid flex select-none px-6">
            <div class="my-4 mr-auto flex w-80 items-center justify-self-start">
                <Link href="/">
                    <img
                        src="/assets/art/logos/emtprep_logo_ondark@2x.png"
                        class="h-[39px] w-[115px]"
                    />
                </Link>
            </div>
            <div class="hidden justify-self-center lg:flex">
                <ul
                    class="relative flex w-full items-center justify-between whitespace-nowrap text-[16px]"
                >
                    <Link
                        as="li"
                        v-for="item in menu.items"
                        :href="item.link"
                        :class="
                            'mx-6 -mb-1 mt-1 flex flex-col justify-center border-b-5 pb-4 pt-5 text-[16px] hover:cursor-pointer hover:text-white' +
                            ' ' +
                            (getCurrentPath() === '/'
                                ? '!text-white'
                                : 'text-white/60') +
                            ' ' +
                            (isActive(item.link)
                                ? 'border-primary-500 !text-white'
                                : 'border-transparent')
                        "
                    >
                        <span>{{ item.name }}</span>
                    </Link>
                </ul>
            </div>
            <div class="ml-auto hidden w-80 justify-self-end lg:flex">
                <div class="ml-auto flex items-center">
                    <ul
                        class="relative flex w-full items-center justify-between whitespace-nowrap"
                    >
                        <li>
                            <div v-if="!$page.props.auth.user">
                                <a
                                    :href="$page.props.site_config.backend_app_login_route"
                                    class="border-b-5 border-transparent px-2 py-4 !text-[16px] text-white hover:cursor-pointer hover:text-white lg:px-4"
                                >
                                    Login
                                </a>
                                <Link
                                    class="btn btn-primary cursor-pointer whitespace-nowrap rounded border-b-4 border-transparent px-4 text-center text-[24px] !font-normal leading-none"
                                    :href="route('frontend.pricing')"
                                >
                                    Buy Membership
                                </Link>
                            </div>
                            <div v-if="$page.props.auth.user">
                                <a
                                    href="/admin/dashboard"
                                    v-if="
                                        $page.props.auth.user
                                            .account_type_label === 'Admin'
                                    "
                                    class="btn btn-secondary cursor-pointer whitespace-nowrap rounded border-b-5 border-transparent px-4 !pb-[8px] !pt-[12px] text-center text-[24px] leading-none"
                                >
                                    Return to Site Admin
                                </a>
                                <a
                                    v-else
                                    class="btn btn-primary btn-sm cursor-pointer whitespace-nowrap rounded border-b-5 border-transparent px-4 !pb-[8px] !pt-[12px] text-center text-[24px] leading-none"
                                    :href="$page.props.site_config.backend_app_login_route"

                                >
                                    Return to
                                    <span
                                        v-if="
                                            $page.props.auth.user
                                                .account_type_label ===
                                            'Group Admin'
                                        "
                                    >Group</span
                                    >
                                    <span v-else>Student</span>
                                    Dashboard
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="flex items-center lg:hidden">
                <slide-over-menu open-from="right">
                    <template #trigger>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1 6C1 5.44772 1.44772 5 2 5H22C22.5523 5 23 5.44772 23 6C23 6.55228 22.5523 7 22 7H2C1.44772 7 1 6.55228 1 6Z"
                                fill="#E1E5E8"
                            />
                            <path
                                d="M1 12C1 11.4477 1.44772 11 2 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H2C1.44772 13 1 12.5523 1 12Z"
                                fill="#E1E5E8"
                            />
                            <path
                                d="M1 18C1 17.4477 1.44772 17 2 17H22C22.5523 17 23 17.4477 23 18C23 18.5523 22.5523 19 22 19H2C1.44772 19 1 18.5523 1 18Z"
                                fill="#E1E5E8"
                            />
                        </svg>
                    </template>
                    <template #menu_content>
                        <div class="flex h-full flex-col bg-white">
                            <div class="flex border-b border-gray-100 p-4">
                                <Link href="/">
                                    <img
                                        src="/assets/art/logos/emtprep_logo_color@2x.png"
                                        class="h-[28px] w-[80px]"
                                    />
                                </Link>
                            </div>
                            <ul class="flex w-full flex-col p-4">
                                <Link
                                    as="li"
                                    v-for="item in menu.items"
                                    :href="item.link"
                                    class="flex h-full w-full flex-col border-b border-gray-100 px-2 py-4 hover:cursor-pointer"
                                >
                                    <span>{{ item.name }}</span>
                                </Link>
                            </ul>
                            <div class="flex-grow"></div>
                            <div class="flex flex-col gap-3 p-4">
                                <template v-if="!$page.props.auth.user">
                                    <Link
                                        :href="route('frontend.pricing')"
                                        class="btn btn-primary btn-lg w-full text-center"
                                    >Buy Membership
                                    </Link>
                                    <a
                                        :href="$page.props.site_config.backend_app_login_route"
                                        class="btn btn-secondary btn-lg w-full text-center"
                                    >Login
                                    </a>
                                </template>
                                <template v-if="$page.props.auth.user">
                                    <a
                                        href="/admin/dashboard"
                                        v-if="
                                            $page.props.auth.user
                                                .account_type_label === 'Admin'
                                        "
                                        class="btn btn-secondary cursor-pointer whitespace-nowrap rounded border-b-5 border-transparent px-4 !pb-[8px] !pt-[12px] text-center text-[24px] leading-none"
                                    >
                                        Return to Site Admin
                                    </a>
                                    <a
                                        v-else
                                        class="btn btn-primary btn-sm cursor-pointer whitespace-nowrap rounded border-b-5 border-transparent px-4 !pb-[8px] !pt-[12px] text-center text-[24px] leading-none"
                                        :href="$page.props.site_config.backend_app_login_route"
                                    >
                                        Return to
                                        <span
                                            v-if="
                                                $page.props.auth.user
                                                    .account_type_label ===
                                                'Group Admin'
                                            "
                                        >Group</span
                                        >
                                        <span v-else>Student</span>
                                        Dashboard
                                    </a>
                                </template>
                            </div>
                        </div>
                    </template>
                </slide-over-menu>
            </div>
        </div>
    </div>
    <div class="pt-[72px] lg:pt-0"></div>
</template>

<script>
import SlideOverMenu from "@/Components/SlideOverMenu";

export default {
    name: "FrontendHeader",
    components: {SlideOverMenu},
    props: {
        focusMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            menu: this.$page.props.frontend_menus.guest_header,
        };
    },
    methods: {
        getCurrentPath() {
            return window.location.pathname;
        },
        isActive(target) {
            return _.startsWith(this.getCurrentPath(), target);
        },
    },
};
</script>
